import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//VENDOR
import VendorReducer from "./vendor/reducer"

// AFFILIATE
import AffiliateReducer from "./affiliate/reducer"



// Dashboard Ecommerce
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";





const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Vendor: VendorReducer,
    Affiliate: AffiliateReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
  
});

export default rootReducer;